module.exports = __webpack_public_path__ + "static/img/menuPelny-OFF.eb32874d.png";